
<ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>

<ng-container *ngIf="enableMasterDetail && offerFeeManagerConfiguration.visible">
  <div class="ct-manager-master-detail-container">
    <offer-fee [configuration]="offerFeeManagerConfiguration"></offer-fee>
  </div>
</ng-container>
`
